export const environment = {
    authServer: process.env.REACT_APP_CLIENT_AUTH_PATH ? process.env.REACT_APP_CLIENT_AUTH_PATH : "",
    onlineAuthenticationServer: process.env.REACT_APP_CLIENT_ONLINE_AUTH_PATH ? process.env.REACT_APP_CLIENT_ONLINE_AUTH_PATH : "",
    cryptoSecretKey: process.env.REACT_APP_CLIENT_CRYPTO_KEY ? process.env.REACT_APP_CLIENT_CRYPTO_KEY : "",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY : "",
    franchiseId: Number(process.env.REACT_APP_FRANCHISE_ID),
}
